import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SpinEditor from "@/pages/SpinEditor";
import AuthCallback from "@/pages/AuthCallback";
import AdminPanel from "@/pages/AdminPanel";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import FreeSpinningRecordVideoMaker from "@/pages/seo/FreeSpinningRecordVideoMaker";
import HowToMakeASpinningRecordVideo from "@/pages/seo/HowToMakeASpinningRecordVideo";
import InstagramVideoDimensions from "@/pages/seo/InstagramVideoDimensions";
import Mp3ToVideo from "@/pages/seo/Mp3ToVideo";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function AppRoutes() {
  const location = useLocation();

  // PostHog's autocapture only fires "$pageview" on the initial script
  // load -- React Router's pushState navigation needs a manual capture on
  // every route change, sent to Waxify's own "wxfy" instance (separate
  // from the Emergent-internal default instance in index.html).
  useEffect(() => {
    window.posthog?.wxfy?.capture?.('$pageview');
  }, [location.pathname]);

  // Google auth redirects back to "/" with #session_id=... in the hash --
  // must be checked here (during render), not in a useEffect, or the
  // normal "/" route renders first and races the session exchange.
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<SpinEditor />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/free-spinning-record-video-maker" element={<FreeSpinningRecordVideoMaker />} />
      <Route path="/how-to-make-a-spinning-record-video" element={<HowToMakeASpinningRecordVideo />} />
      <Route path="/instagram-video-dimensions" element={<InstagramVideoDimensions />} />
      <Route path="/mp3-to-video" element={<Mp3ToVideo />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
